import type { RouteRecordRaw } from 'vue-router'

const incidentRoutes: RouteRecordRaw[] = [
  {
    path: 'incidents',
    component: () => import('@/views/incident/IncidentLayout.vue'),
    children: [
      {
        path: '',
        name: 'incidents',
        component: () => import('@/views/incident/IncidentList.vue')
      },
      {
        path: 'config',
        name: 'incident-config',
        component: () => import('@/views/incident/IncidentConfig.vue')
      },
      {
        path: 'resolved',
        name: 'incident-resolved',
        component: () => import('@/views/incident/IncidentResolvedList.vue')
      },
      {
        path: 'reminder-rules',
        redirect: '/incidents/config?tab=rules'
      },
      {
        path: 'reminder-logs',
        redirect: '/incidents/config?tab=logs'
      },
      {
        path: ':id',
        name: 'incident-detail',
        component: () => import('@/views/incident/IncidentDetail.vue')
      }
    ]
  }
]

export default incidentRoutes
